module.exports = __webpack_public_path__ + "static/media/nextexchnage.380b98ac.png";